'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCheck } from '@subframe/core';
import { useRouter } from 'next/navigation';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { CATEGORY_LABEL } from '@/shared/constants/notificationCategories';
import type { FonteNotificacoes, NotificacaoCategoria, NotificacaoItem } from '@/types/notificationBell/types';
import { categoryFilterChanged, markAllNotificationsAsRead, markNotificationAsRead, selectActiveTab, selectAvailableCategories, selectCategoryFilter, selectFilteredItems, selectFilteredItemsByEntityType, selectUnreadCount, selectUnreadCountByEntityType, tabChanged } from '../store';
import { destinoDoItemDoSino } from '../utils/destinoDoItemDoSino';
import { NotificationEmptyState } from './NotificationEmptyState';
import { NotificationItem } from './NotificationItem';
interface NotificationDropdownProps {
  fonte: FonteNotificacoes;
  onlyEntityType?: 'ConversaPendencia';
  onItemClick?: (item: NotificacaoItem) => void;
  itemAtivavel?: (item: NotificacaoItem) => boolean;
  onRequestClose: () => void;
}
export function NotificationDropdown(t0) {
  const $ = _c(65);
  const {
    fonte,
    onlyEntityType,
    onItemClick,
    itemAtivavel,
    onRequestClose
  } = t0;
  const dispatch = useAppDispatch();
  const router = useRouter();
  const activeTab = useAppSelector(selectActiveTab);
  let t1;
  if ($[0] !== fonte || $[1] !== onlyEntityType) {
    t1 = state => onlyEntityType ? selectFilteredItemsByEntityType(state, fonte, onlyEntityType) : selectFilteredItems(state, fonte);
    $[0] = fonte;
    $[1] = onlyEntityType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const items = useAppSelector(t1);
  let t2;
  if ($[3] !== fonte || $[4] !== onlyEntityType) {
    t2 = state_0 => onlyEntityType ? selectUnreadCountByEntityType(state_0, fonte, onlyEntityType) : selectUnreadCount(state_0, fonte);
    $[3] = fonte;
    $[4] = onlyEntityType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const unreadCount = useAppSelector(t2);
  let t3;
  if ($[6] !== fonte) {
    t3 = state_1 => selectAvailableCategories(state_1, fonte);
    $[6] = fonte;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const availableCategories = useAppSelector(t3);
  const categoryFilter = useAppSelector(selectCategoryFilter);
  const scoped = Boolean(onlyEntityType);
  const mostraVerTodas = !scoped && fonte === "workspace";
  let t4;
  if ($[8] !== dispatch || $[9] !== fonte || $[10] !== items || $[11] !== scoped) {
    t4 = () => {
      if (scoped) {
        items.filter(_temp).forEach(item_0 => {
          dispatch(markNotificationAsRead({
            id: item_0.id,
            fonte
          }));
        });
        return;
      }
      dispatch(markAllNotificationsAsRead(fonte));
    };
    $[8] = dispatch;
    $[9] = fonte;
    $[10] = items;
    $[11] = scoped;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleMarkAll = t4;
  let t5;
  if ($[13] !== onRequestClose || $[14] !== router) {
    t5 = () => {
      onRequestClose();
      router.push("/notificacoes");
    };
    $[13] = onRequestClose;
    $[14] = router;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleVerTodas = t5;
  let t6;
  if ($[16] !== dispatch || $[17] !== fonte || $[18] !== onItemClick || $[19] !== onRequestClose || $[20] !== router) {
    t6 = (item_1, destino) => {
      onItemClick?.(item_1);
      if (!item_1.lida) {
        dispatch(markNotificationAsRead({
          id: item_1.id,
          fonte
        }));
      }
      onRequestClose();
      if (destino) {
        router.push(destino);
      }
    };
    $[16] = dispatch;
    $[17] = fonte;
    $[18] = onItemClick;
    $[19] = onRequestClose;
    $[20] = router;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const handleItemClick = t6;
  let t7;
  if ($[22] !== handleItemClick || $[23] !== itemAtivavel || $[24] !== onItemClick) {
    t7 = item_2 => {
      if (onItemClick) {
        return itemAtivavel?.(item_2) ?? true ? () => handleItemClick(item_2) : undefined;
      }
      const destino_0 = destinoDoItemDoSino(item_2);
      return destino_0 ? () => handleItemClick(item_2, destino_0) : undefined;
    };
    $[22] = handleItemClick;
    $[23] = itemAtivavel;
    $[24] = onItemClick;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const ativarItem = t7;
  let t8;
  if ($[26] !== dispatch) {
    t8 = cat => {
      dispatch(categoryFilterChanged(cat));
    };
    $[26] = dispatch;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const handleCategoryClick = t8;
  const t9 = scoped ? "Lembretes" : "Notifica\xE7\xF5es";
  let t10;
  if ($[28] !== unreadCount) {
    t10 = unreadCount > 0 && <span className="bg-error-50 text-error-600 border-error-200 ml-2 rounded-full border px-[7px] py-[1px] text-[11px] leading-none font-semibold">{unreadCount > 99 ? "99+" : unreadCount} novas</span>;
    $[28] = unreadCount;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t9) {
    t11 = <span className="text-default-font flex items-center text-[15px] font-bold">{t9}{t10}</span>;
    $[30] = t10;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== handleMarkAll || $[34] !== unreadCount) {
    t12 = unreadCount > 0 && <button type="button" onClick={handleMarkAll} className="text-brand-600 hover:bg-brand-50 flex items-center gap-[5px] rounded-md px-1 py-[2px] text-xs font-medium transition-colors"><FeatherCheckCheck className="h-[14px] w-[14px]" />Marcar todas como lidas</button>;
    $[33] = handleMarkAll;
    $[34] = unreadCount;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t11 || $[37] !== t12) {
    t13 = <div className="flex items-center justify-between px-4 pt-[14px]">{t11}{t12}</div>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["unread", "all"];
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== activeTab || $[41] !== dispatch) {
    t15 = <div className="flex gap-[2px] border-b border-neutral-100 px-4 pt-[10px]">{(t14 as const).map(t => <button key={t} type="button" onClick={() => dispatch(tabChanged(t))} className={`-mb-px rounded-t border-b-2 px-3 py-[6px] text-[13px] font-medium transition-colors ${activeTab === t ? "text-brand-600 border-brand-600" : "text-subtext-color border-transparent"}`}>{t === "unread" ? "N\xE3o lidas" : "Todas"}</button>)}</div>;
    $[40] = activeTab;
    $[41] = dispatch;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== availableCategories || $[44] !== categoryFilter || $[45] !== handleCategoryClick || $[46] !== scoped) {
    t16 = !scoped && availableCategories.length > 1 && <div className="scrollbar-hidden flex gap-[6px] overflow-x-auto border-b border-neutral-100 px-4 py-[8px]"><button type="button" onClick={() => handleCategoryClick(null)} className={`shrink-0 rounded-md px-[8px] py-[3px] text-[11px] font-medium transition-colors ${categoryFilter === null ? "bg-brand-100 text-brand-700" : "text-subtext-color hover:bg-neutral-100"}`}>Todas</button>{availableCategories.map(cat_0 => <button key={cat_0} type="button" onClick={() => handleCategoryClick(cat_0)} className={`shrink-0 rounded-md px-[8px] py-[3px] text-[11px] font-medium transition-colors ${categoryFilter === cat_0 ? "bg-brand-100 text-brand-700" : "text-subtext-color hover:bg-neutral-100"}`}>{CATEGORY_LABEL[cat_0]}</button>)}</div>;
    $[43] = availableCategories;
    $[44] = categoryFilter;
    $[45] = handleCategoryClick;
    $[46] = scoped;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== activeTab || $[49] !== ativarItem || $[50] !== fonte || $[51] !== items || $[52] !== scoped) {
    t17 = items.length === 0 ? <NotificationEmptyState tab={activeTab} scoped={scoped} /> : items.map(item_3 => <NotificationItem key={item_3.id} item={item_3} fonte={fonte} scoped={scoped} onActivate={ativarItem(item_3)} />);
    $[48] = activeTab;
    $[49] = ativarItem;
    $[50] = fonte;
    $[51] = items;
    $[52] = scoped;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== t17) {
    t18 = <div className="max-h-[380px] overflow-y-auto">{t17}</div>;
    $[54] = t17;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== handleVerTodas || $[57] !== mostraVerTodas) {
    t19 = mostraVerTodas ? <div className="flex justify-center border-t border-neutral-100 px-4 py-[10px]"><button type="button" onClick={handleVerTodas} className="text-brand-600 hover:bg-brand-50 rounded-md px-2 py-1 text-[13px] font-medium transition-colors">Ver todas as notificações →</button></div> : null;
    $[56] = handleVerTodas;
    $[57] = mostraVerTodas;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== t13 || $[60] !== t15 || $[61] !== t16 || $[62] !== t18 || $[63] !== t19) {
    t20 = <div className="w-[400px] overflow-hidden rounded-[16px] border border-neutral-200 bg-white shadow-lg">{t13}{t15}{t16}{t18}{t19}</div>;
    $[59] = t13;
    $[60] = t15;
    $[61] = t16;
    $[62] = t18;
    $[63] = t19;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  return t20;
}
function _temp(item) {
  return !item.lida;
}